import { TYPOGRAPHY } from "@store/theme/common/design";
import { inputLabelStyles, inputStyles } from "@store/theme/common/mixins";
import { css } from "styled-components";

export default {
    defaultProps: {
        border: "rectangle",
        labelProps: {
            size: TYPOGRAPHY.size.small,
            weight: TYPOGRAPHY.weight.bold,
        },
        errorProps: {
            size: TYPOGRAPHY.size.smaller,
            weight: TYPOGRAPHY.weight.base,
        },
        hintProps: {
            size: TYPOGRAPHY.size.smaller,
            weight: TYPOGRAPHY.weight.base,
        },
        cssOverrides: {
            formField: css`
                label {
                    ${inputLabelStyles()}
                }

                textarea {
                    ${inputStyles()}
                    resize: vertical;
                }
            `,
            formInputWrapper: css`
                margin-top: 6px !important;
                margin-bottom: 10px;
            `,
            inputSelect: css`
                ${inputStyles()}
            `,
            descriptionWrapper: css`
                line-height: ${TYPOGRAPHY.lineHeight.small};
            `,
        },
    },
};
